import { render, staticRenderFns } from "./PetHeader.vue?vue&type=template&id=22678013&scoped=true&"
import script from "./PetHeader.vue?vue&type=script&lang=js&"
export * from "./PetHeader.vue?vue&type=script&lang=js&"
import style0 from "./PetHeader.vue?vue&type=style&index=0&id=22678013&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22678013",
  null
  
)

export default component.exports